import { ToastOptions, toast } from "react-toastify";
import Swal, { SweetAlertOptions } from "sweetalert2";

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
// import { ToastOptions, toast } from 'react-toastify';
import { toast as toast1 } from 'react-hot-toast';


const showNotification = (type: string, msg: string, options = {}) => {
  const defaultOptions: ToastOptions = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: "smart-toaster",
  };
  const mergedOptions = { ...defaultOptions, ...options };
  if (type === "success") {
    return toast.success(msg, { ...mergedOptions });
  } else if (type === "error") {
    return toast.error(msg, { ...mergedOptions });
  } else if (type === "warn") {
    return toast.warn(msg, mergedOptions);
  } else if (type === "info") {
    return toast.info(msg, mergedOptions);
  }
};

const showAlert = (
  title: string,
  text: string,
  icon: SweetAlertOptions["icon"] = "info"
) => {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
  });
};

const showAlertAutoClose = (
  text: string,
  icon: SweetAlertOptions["icon"] = "info",
  timer = 2000
) => {  
  Swal.fire({
    title: "",
    text: text,
    icon: icon,
    timer: timer,
    showConfirmButton: false,
  });
};

const showAlertAutoCloseHtml = (
  html: any,
  icon: SweetAlertOptions["icon"] = "info",
  timer = 20000
) => {
  Swal.fire({
    title: "",
    html: html,
    icon: icon,
    timer: timer,
    showConfirmButton: true,
  });
};

const showYesOrNoAlert = (
  text: string,
  call_back: any,
  icon: SweetAlertOptions["icon"]
) => {
  Swal.fire({
    title: "",
    icon: icon,
    text: text,
    showConfirmButton: true, // Show the "Yes" button
    showCancelButton: true, // Show the "No" button
    cancelButtonText: "No", // Text for the "No" button
    confirmButtonText: "Yes", // Text for the "Yes" button
    allowOutsideClick: false,
  }).then((result) => {
    // Handle the result after the user clicks on "Yes" or "No"
    if (result.isConfirmed) {
      call_back("yes");
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      call_back("no");
    }
  });
};

type notifyType = "success" | "error"

const showNotification1 = (type: notifyType, msg: string, position?: string, icon?:string )   => {
  let toastPosition ={};
  if(position) {
    toastPosition = {position: position}
  }

  if(icon) return toast1(msg, { icon: icon })
  
  switch (type) {
    case "success": return toast1.success(msg, toastPosition)
    case "error": return toast1.error(msg, toastPosition)
  }
}

interface yesornobuttons {
  label: string;
  className: string;
  onClick: ()=>void
}

interface showYNprops {
  buttons? : yesornobuttons[];
  merge?   : boolean | 1 | 2,
  labels?  : string[]
}
  
const showYesOrNoAlert1 = (
  text      : string,
  call_back : any,
  // buttons?  : yesornobuttons[],
  // merge?    : boolean | 1 | 2,
  props     : showYNprops = {}
) => {
  const defaultButtons = [
    { label: 'Confirm', className: 'confirm-btn-yes', onClick: () => call_back?.("yes") },
    { label: 'Cancel', className: 'confirm-btn-no', onClick: () => call_back?.("no") }
  ];
  const { labels, buttons, merge } = props

  if(labels){
    if(labels[0]) defaultButtons[0].label = labels[0]
    if(labels[1]) defaultButtons[1].label = labels[1]
  }

  const finalButtons = buttons
    ? merge === true
      ? [...buttons, ...defaultButtons]
      : typeof merge === "number"
        ? [...buttons, defaultButtons[merge - 1]]
        : buttons
    : defaultButtons;

  confirmAlert({
    title: "",
    message: text,
    buttons: finalButtons,
    closeOnEscape: true,
    closeOnClickOutside: true,
  });
};


export {
  showAlert,
  showAlertAutoClose,
  showAlertAutoCloseHtml,
  showNotification,
  showNotification1,
  showYesOrNoAlert,
  showYesOrNoAlert1
};